import { render } from "./PriceListPropagateFurnizorFieldsDialog.vue?vue&type=template&id=6bd793dc&scoped=true"
import script from "./PriceListPropagateFurnizorFieldsDialog.vue?vue&type=script&lang=js"
export * from "./PriceListPropagateFurnizorFieldsDialog.vue?vue&type=script&lang=js"

import "./PriceListPropagateFurnizorFieldsDialog.vue?vue&type=style&index=0&id=6bd793dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd793dc"]])

export default __exports__